import React from 'react';

const PaymentSuccessPage = ({ onSignOut }) => {
  return (
    <div className="flex items-center justify-center min-h-screen bg-green-50 font-sans">
      <div className="bg-white p-8 rounded-lg shadow-xl w-full max-w-md text-center">
        <h2 className="text-2xl font-bold mb-4 text-green-700">Payment Successful!</h2>
        <p className="text-gray-700 mb-6">
          Your payment was successful.<br />
          For security, please log out and log in again to access your account.
        </p>
        <button
          onClick={onSignOut}
          className="w-full py-2 px-4 bg-red-600 text-white font-semibold rounded-md shadow-md hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-opacity-75 transition duration-200 ease-in-out"
        >
          Log Out
        </button>
      </div>
    </div>
  );
};

export default PaymentSuccessPage;